<template>
  <div>
    <el-form label-width="120px" size="mini" :inline="true" :model="addForm" ref="addForm">
      <el-form-item label="上传文件">
        <el-upload
          class="upFile"
          :auto-upload="false"
          :show-file-list="false"
          drag
          multiple
          :on-change="UploadImage"
          :file-list="fileList"
          action="#"
        >
          <i class="el-icon-upload" v-if="!addForm.file_url">
            <span class="fontStyle1">
              将Pdf文件拖到此处，或
              <span class="fontStyle2">点击上传</span>
            </span>
          </i>
          <div
            class="upFile"
            v-else
            :style="{'background-image': 'url(' + addForm.file_url + ')','width':'360px','height':'180px','background-size':'cover','margin-bottom':'200px'}"
          >
            <span class="fontStyle3">
              <i
                class="el-icon-zoom-in"
                @click="openWin('../../static/typeImg.html?typeImage=' +addForm.file_url)"
              >查看图片</i>
              <i class="el-icon-delete-solid" @click.stop="delImg">删除</i>
              <i class="el-icon-refresh-right" slot="trigger">重新上传</i>
            </span>
          </div>
        </el-upload>
      </el-form-item>
      <!--    <el-form-item>-->
      <!--      <el-link type="primary" v-if="addForm.file_url" :href="addForm.file_url" target="_blank">下载查看-{{addForm.file_url}}</el-link>-->
      <!--    </el-form-item>-->
      <!--    <el-form-item>-->
      <!--      <el-button type="primary" @click="addFormSubmit">导入</el-button>-->
      <!--    </el-form-item>-->
    </el-form>
    <!-- 全局遮罩 图片上传 -->
    <el-dialog
      :visible.sync="dialogVisible"
      :modal="true"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      width="50%"
    >
      <div class="loading-overlay">
        <div class="loading-spinner" style="font-size:30px;font-weight: bold">
          <i class="el-icon-upload"></i>
          文件上传ing
          <i class="el-icon-loading"></i>
        </div>
      </div>
    </el-dialog>
  </div>
</template>
<script>
export default {
  name: "excelImport",
  data() {
    return {
      addForm: {
        file_url: "",
      },
      dialogVisible: false,
      fileList: [],
    };
  },
  methods: {
    UploadImage(file, fileList) {
      this.fileList = fileList.slice(-3);
      console.log(file, fileList, 1);
      let _this = this;
      _this.dialogVisible = true;
      // this.addForm.file_url = URL.createObjectURL(file.raw);

      let payFd = new FormData();
      payFd.append("file", file.raw);
      // payFd.append('company_id', sessionStorage.getItem('company_id'))
      payFd.append("access_token", sessionStorage.getItem("token"));
      this.$axios
        .orderPdfImport(payFd)
        .then((res) => {
          if (res.code == 200) {
            console.log(res.data, 11111111111111111111111);
            _this.addForm.file_url = res.data.src;
            this.$message.success(res.msg);
            _this.dialogVisible = false;
          } else {
            _this.dialogVisible = false;
            this.$message.error(res.msg);
          }
        })
        .catch((error) => console.log("UploadImage-error", error));
    },
    delImg() {
      this.addForm.file_url = "";
    },
    addFormSubmit() {
      if (!this.addForm.file_url) {
        this.$message.error("请上传Excel文件");
        return false;
      }
    },
  },
};
</script>
<style lang="less" scoped>
///deep/.el-upload-dragger.upFile {
//  width: 360px !important;
//  height: 180px !important;
//}
.fontStyle1 {
  display: block;
  font-size: 14px;
  color: #606266;
}
.fontStyle2,
.fontStyle3 {
  font-size: 14px;
  color: #3a8ee6;
}
.fontStyle3 {
  font-size: 22px;
  color: #999;
  position: absolute;
  bottom: 1px;
  right: 1px;
}
</style>


// WEBPACK FOOTER //
// src/view/common/excelImport.vue